// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1JbA9","header":"Messages_header__15vb2"};